import React from 'react';
import { Form } from 'react-final-form';

import FormField from 'components/Form/FormField';
import {
  required,
  composeValidators,
  mustBeNumber,
} from 'utils/formValidators';
import 'assets/scss/soonoGetStarted.css';

const ChargeCreditCardForm = ({ setChargeDetails, handleNext, onCancel }) => {
  const onSubmit = values => {
    setChargeDetails(values);
    handleNext();
  };

  return (
    <Form
      onSubmit={onSubmit}
      render={({ handleSubmit, form, submitting }) => (
        <form className="form mt-4 mb-5 text-left text-dark soono-transaction-form px-4">
          <div className="row">
            <FormField
              label="Amount"
              name="amount"
              placeholder="$60"
              containerClassName="form-group col mb-5"
              inputClassName="form-control pxy-3 pl-4 pr-4"
              validate={composeValidators(required, mustBeNumber)}
            />
          </div>
          <div className="row  mb-2">
            <FormField
              label="Description"
              name="description"
              containerClassName="form-group col"
              inputClassName="form-control py-3 pl-4 pr-4"
              placeholder="What is the charge?"
              textArea
              validate={required}
            />
          </div>
          <div className="form-group mt-4 d-flex justify-content-center align-items-baseline">
            <button
              type="button"
              onClick={onCancel}
              disabled={submitting}
              className="btn btn-sm px-4 mr-2 border-0 bg-transparent text-center mt-4"
            >
              Cancel
            </button>
            <button
              className="btn-warning px-5 py-2 text-white border-0"
              type="submit"
              onClick={handleSubmit}
            >
              Continue
            </button>
          </div>
        </form>
      )}
    />
  );
};

export default ChargeCreditCardForm;



// WEBPACK FOOTER //
// ./src/components/Form/payment/chargeCreditCard.js